module.exports = __webpack_public_path__ + "static/media/RecomendaMaceio.ea8f70ef.jpg";